<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8q8m46/tc-custom/9781449413811.jpg?1711135570710" alt="This image is the cover for the book Mom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mom
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Cathy</i> is like a longtime friend who shares the same fears and frustrations as most women: the frightening sight of too-tight swimsuits in a dressing room mirror, the relentless call of the refrigerator, and men who are never quite right. This gift book features one of Cathy's most popular subjects: Mom. This is a cartoon soul mate. Readers will find comfort, solace, and lots of laughs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cathy Guisewite
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fdfe0ea